var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShopify({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_di_48_945)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 32,
    width: 64,
    height: 64,
    rx: 32,
    fill: "#B7A2FF",
    fillOpacity: 0.2,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.8666 54.7999C67.8666 54.7999 67.5999 54.8799 67.1466 55.0266C67.0666 54.7866 66.9599 54.4799 66.7999 54.1866C66.2932 53.2132 65.5466 52.7066 64.6399 52.6932C64.5732 52.6932 64.5199 52.6932 64.4532 52.7066C64.4266 52.6799 64.3999 52.6399 64.3732 52.6132C63.9866 52.1866 63.4799 51.9866 62.8799 51.9999C61.7199 52.0399 60.5599 52.8799 59.6132 54.3732C58.9466 55.4266 58.4532 56.7466 58.3066 57.7599C56.9732 58.1732 56.0399 58.4666 56.0132 58.4666C55.3332 58.6799 55.3199 58.7066 55.2266 59.3332C55.1599 59.8132 53.3999 73.4666 53.3999 73.4666L68.0399 75.9999V54.7732C67.9732 54.7732 67.9066 54.7866 67.8666 54.7999ZM64.4799 55.8532C63.7066 56.0932 62.8532 56.3599 62.0132 56.6132C62.2532 55.6932 62.7066 54.7866 63.2666 54.1866C63.4799 53.9599 63.7599 53.7199 64.1066 53.5732C64.4266 54.2532 64.4932 55.1999 64.4799 55.8532ZM62.8932 52.7732C63.1599 52.7732 63.3999 52.8266 63.5999 52.9599C63.2799 53.1199 62.9866 53.3599 62.6932 53.6666C61.9599 54.4532 61.3866 55.6932 61.1599 56.8799C60.4532 57.0932 59.7732 57.3066 59.1332 57.5066C59.5332 55.6266 61.1066 52.8266 62.8932 52.7732ZM60.6266 63.4266C60.7066 64.6666 63.9866 64.9466 64.1732 67.8666C64.3199 70.1599 62.9599 71.7332 60.9866 71.8532C58.6399 71.9999 57.3332 70.6132 57.3332 70.6132L57.8266 68.4932C57.8266 68.4932 59.1332 69.4799 60.1732 69.4132C60.8532 69.3732 61.0932 68.8132 61.0799 68.4266C60.9732 66.7999 58.3066 66.8932 58.1466 64.2266C57.9999 61.9732 59.4799 59.7066 62.7332 59.4932C63.9999 59.4132 64.6399 59.7332 64.6399 59.7332L63.8932 62.5199C63.8932 62.5199 63.0666 62.1466 62.0799 62.1999C60.6399 62.2932 60.6132 63.1999 60.6266 63.4266ZM65.2532 55.6132C65.2399 55.0266 65.1732 54.1999 64.8932 53.4932C65.7732 53.6666 66.2132 54.6532 66.3999 55.2532C66.0666 55.3599 65.6799 55.4799 65.2532 55.6132ZM68.5199 75.9466L74.5999 74.4399C74.5999 74.4399 71.9866 56.7599 71.9732 56.6399C71.9599 56.5199 71.8532 56.4532 71.7599 56.4399C71.6666 56.4266 69.9599 56.3999 69.9599 56.3999C69.9599 56.3999 68.9199 55.3866 68.5199 54.9999V75.9466Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_di_48_945",
    x: 0,
    y: 0,
    width: 128,
    height: 128,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.717647 0 0 0 0 0.635294 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_48_945"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_48_945",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.717093 0 0 0 0 0.635577 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_48_945"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShopify);
export default __webpack_public_path__ + "static/media/Shopify.29ab0d3009e73ca9b14d15f762c9786f.svg";
export { ForwardRef as ReactComponent };